import React, { useState } from "react";
export default function StudyWorkDubaiLanding() {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form).entries());

    try {
      // TODO: replace with your actual endpoint or Apps Script URL
      const res = await fetch("/api/inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error("Network response was not ok");
      alert("Thank you! Your inquiry has been submitted. Our team will contact you soon.");
      form.reset();
    } catch (err) {
      console.error(err);
      alert("Sorry, there was an issue submitting the form. Please try again.");
    }
  };

  const InquiryForm = ({ variant = "primary" }) => (
    <form onSubmit={handleSubmit} className={`w-full grid grid-cols-1 md:grid-cols-2 gap-3 ${variant === "primary" ? "" : ""}`}>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">Full Name*</label>
        <input name="fullName" required placeholder="Your name" className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">Email*</label>
        <input type="email" name="email" required placeholder="you@example.com" className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">Phone (WhatsApp)*</label>
        <input name="phone" required placeholder="+91…" className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">Current Profile*</label>
        <select name="profile" required className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500">
          <option value="">Select</option>
          <option>12th Pass</option>
          <option>Undergraduate Student</option>
          <option>Working Professional</option>
        </select>
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">Interested Program</label>
        <input name="program" placeholder="Tourism & Hospitality, etc." className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium text-slate-700">City</label>
        <input name="city" placeholder="Your city" className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-slate-700">Message</label>
        <textarea name="message" rows={3} placeholder="Tell us your goals or questions" className="mt-1 w-full rounded-xl border border-slate-300 p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div className="md:col-span-2 flex items-start gap-2">
        <input id="consent" name="consent" type="checkbox" className="mt-1 h-4 w-4 rounded border-slate-300" required />
        <label htmlFor="consent" className="text-sm text-slate-600">I agree to be contacted by UniThink Education International via phone/WhatsApp/email.</label>
      </div>
      <div className="md:col-span-2">
        <button type="submit" className="w-full md:w-auto rounded-xl bg-indigo-600 px-6 py-3 font-semibold text-white shadow hover:bg-indigo-700 active:scale-[.98]">Book Your Free Consultation</button>
      </div>
    </form>
  );

  const Feature = ({ title, desc }) => (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md transition">
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      <p className="mt-2 text-sm text-slate-600">{desc}</p>
    </div>
  );

  const FAQ = ({ q, a, idx }) => (
    <details className="group rounded-2xl border border-slate-200 bg-white p-5 open:shadow-sm" open={idx === 0}>
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4">
        <span className="text-sm md:text-base font-semibold text-slate-900">{q}</span>
        <span className="shrink-0 rounded-full border border-slate-300 px-2 py-0.5 text-xs text-slate-700 group-open:hidden">+</span>
        <span className="shrink-0 rounded-full border border-slate-300 px-2 py-0.5 text-xs text-slate-700 hidden group-open:inline">−</span>
      </summary>
      <p className="mt-3 text-sm text-slate-600">{a}</p>
    </details>
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-white text-slate-900">
      {/* Header / Nav */}
      

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10 opacity-70 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-indigo-100 via-white to-white" />
        <div className="mx-auto max-w-7xl px-4 py-10 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            
            <h1 className="text-3xl md:text-5xl font-extrabold leading-tight">
              Can You <span className="underline decoration-indigo-400 decoration-4 underline-offset-4">Work While Studying</span> in Dubai?
            </h1>
            <p className="mt-4 text-slate-600 text-base md:text-lg">
              Short answer: <span className="font-semibold">Yes—if you choose the right program and follow the rules.</span> Study in a world-class city and start building your career with part‑time work and internships while you learn.
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="rounded-2xl border border-slate-200 bg-white p-4 text-center">
                <p className="text-2xl md:text-3xl font-extrabold">200+</p>
                <p className="text-xs text-slate-600">Nationalities</p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-white p-4 text-center">
                <p className="text-2xl md:text-3xl font-extrabold">Tax‑Free</p>
                <p className="text-xs text-slate-600">Earnings</p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-white p-4 text-center">
                <p className="text-2xl md:text-3xl font-extrabold">Global</p>
                <p className="text-xs text-slate-600">Career Hub</p>
              </div>
            </div>
          </div>

          {/* Top Inquiry Card */}
          <div id="inquiry-top" className="rounded-3xl border border-slate-200 bg-white/80 p-5 md:p-6 shadow-xl backdrop-blur">
            <h2 className="text-xl md:text-2xl font-bold">Study & Work in Dubai — Start Your Journey</h2>
            <p className="mt-1 text-sm text-slate-600">Book a free 1:1 consultation. Get program shortlists, timelines, and a plan to earn while you learn.</p>
            <div className="mt-4">
              <InquiryForm />
            </div>
            <p className="mt-3 text-xs text-slate-500">We respect your privacy. No spam—ever.</p>
          </div>
        </div>
      </section>

      {/* Tagline Headings */}
      <section className="mx-auto max-w-7xl px-4 pb-4 md:pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-center">
          <div className="rounded-2xl bg-indigo-600 text-white px-4 py-6 shadow">
            <h3 className="text-lg md:text-xl font-bold">Study in Dubai</h3>
            <p className="mt-1 text-sm text-indigo-50">World-class education in a future‑ready city.</p>
          </div>
          <div className="rounded-2xl bg-slate-900 text-white px-4 py-6 shadow">
            <h3 className="text-lg md:text-xl font-bold">Study & Work</h3>
            <p className="mt-1 text-sm text-slate-300">Earn part‑time, build experience, grow your network.</p>
          </div>
          <div className="rounded-2xl bg-amber-500 text-slate-900 px-4 py-6 shadow">
            <h3 className="text-lg md:text-xl font-bold">Study & Work in Dubai</h3>
            <p className="mt-1 text-sm text-slate-800">Your launchpad to global careers.</p>
          </div>
        </div>
      </section>

      {/* Why Dubai / Benefits */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:py-12">
        <h2 className="text-2xl md:text-3xl font-extrabold">Why Choose Dubai?</h2>
        <p className="mt-2 text-slate-600 max-w-3xl">Study in a multicultural, innovation‑driven city and gain practical experience alongside your diploma. Here’s what makes Dubai stand out:</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Feature title="Globally Recognized Education" desc="High‑quality programs with strong industry links and international credibility." />
          <Feature title="200+ Nationalities" desc="Learn with peers from around the world and build a powerful global network." />
          <Feature title="Gateway Location" desc="Strategic hub connecting Asia, Europe & Africa—ideal for travel and careers." />
          <Feature title="Modern Infrastructure" desc="High‑tech campuses, safe city, efficient transport—perfect for student life." />
          <Feature title="Tax‑Free Earnings" desc="Keep what you earn from part‑time roles and internships during studies." />
          <Feature title="Post‑Study Pathways" desc="Friendly options to stay, work and grow your career after graduation." />
        </div>
      </section>

      {/* How It Works */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:py-12">
        <div className="rounded-3xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
          <h2 className="text-2xl md:text-3xl font-extrabold">How the Study‑and‑Work Path Works</h2>
          <ol className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <li className="rounded-2xl bg-indigo-50 p-5 ring-1 ring-indigo-100">
              <p className="text-sm font-semibold text-indigo-800">Step 1</p>
              <h3 className="text-lg font-bold">Enroll & Arrive</h3>
              <p className="mt-1 text-sm text-slate-600">Choose a practical, industry‑focused program. Arrive in Dubai to begin classes.</p>
            </li>
            <li className="rounded-2xl bg-amber-50 p-5 ring-1 ring-amber-100">
              <p className="text-sm font-semibold text-amber-900">Step 2</p>
              <h3 className="text-lg font-bold">Get Emirates ID</h3>
              <p className="mt-1 text-sm text-slate-600">Within the first few months, complete visa formalities & receive your Emirates ID.</p>
            </li>
            <li className="rounded-2xl bg-emerald-50 p-5 ring-1 ring-emerald-100">
              <p className="text-sm font-semibold text-emerald-900">Step 3</p>
              <h3 className="text-lg font-bold">Earn While You Learn</h3>
              <p className="mt-1 text-sm text-slate-600">Apply for permitted part‑time roles, gain experience, and build your CV.</p>
            </li>
          </ol>
          <p className="mt-4 text-xs text-slate-500">Note: Work permissions depend on program, institution, and local regulations. We’ll guide you through the right path.</p>
        </div>
      </section>

      {/* Program Focus */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl font-extrabold">Practical Diplomas that Build Real Skills</h2>
            <p className="mt-2 text-slate-600">Prefer learning by doing? Choose programs that emphasize hands‑on training, internships, and industry projects—especially in Tourism & Hospitality Management. Translate classroom knowledge into real‑world value and graduate with experience that employers notice.</p>
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-slate-700">
              <li className="rounded-xl bg-white p-3 ring-1 ring-slate-200">Internships & part‑time roles</li>
              <li className="rounded-xl bg-white p-3 ring-1 ring-slate-200">Career services & job fairs</li>
              <li className="rounded-xl bg-white p-3 ring-1 ring-slate-200">Industry mentors & workshops</li>
              <li className="rounded-xl bg-white p-3 ring-1 ring-slate-200">Portfolio & CV building support</li>
            </ul>
          </div>
          <div className="order-1 lg:order-2">
            <div className="aspect-[4/3] w-full rounded-3xl bg-gradient-to-br from-indigo-200 via-indigo-50 to-white ring-1 ring-indigo-100 shadow-inner grid place-content-center">
              <div className="mx-auto text-center">
                <div className="mx-auto h-16 w-16 rounded-2xl bg-slate-900 text-white grid place-content-center text-lg font-bold">DXB</div>
                <p className="mt-3 text-slate-700 font-semibold">Study • Work • Grow</p>
                <p className="text-xs text-slate-500">(Replace with program artwork or campus image)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:py-12">
        <h2 className="text-2xl md:text-3xl font-extrabold">FAQs</h2>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <FAQ idx={0} q="Can I work while studying in Dubai?" a="Yes—once you have the required permissions and Emirates ID, certain part‑time roles are permitted alongside your studies. We’ll help you choose the right pathway." />
          <FAQ q="Do I need IELTS?" a="Many institutions accept applications without IELTS if you meet their English requirements. We’ll match you with options that fit your profile." />
          <FAQ q="What kind of jobs can students do?" a="Campus roles, internships, hospitality & retail roles, and project‑based work depending on your program and schedule." />
          <FAQ q="Is there a path to stay after graduation?" a="Yes, there are friendly post‑study options and employers often sponsor work visas for suitable candidates." />
        </div>
      </section>

      {/* Bottom CTA + Inquiry */}
      <section id="inquiry-bottom" className="mx-auto max-w-7xl px-4 pb-16">
        <div className="rounded-3xl border border-indigo-200 bg-gradient-to-br from-indigo-600 to-indigo-500 p-6 md:p-10 text-white shadow-lg">
          <h2 className="text-2xl md:text-3xl font-extrabold">Ready to Study & Work in Dubai?</h2>
          <p className="mt-2 text-indigo-50">Get a personalized plan—program shortlist, timelines, and guidance to start earning while learning.</p>
          <div className="mt-6 bg-white/95 p-4 md:p-6 rounded-2xl shadow">
            <InquiryForm variant="secondary" />
          </div>
          <p className="mt-3 text-xs text-indigo-100">By submitting, you agree to be contacted about admissions guidance.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200">
        <div className="mx-auto max-w-7xl px-4 py-6 text-center text-sm text-slate-500">
          ©️ {new Date().getFullYear()} UniThink Education International • Study in Dubai • Study & Work in Dubai
        </div>
      </footer>
    </div>
  );
}